import { TTableColumnsFilter, TTableColumnTitles } from '@shared/components/Table';
import { IBaseRequestQuery, IDataResponse } from '@shared/types/fetch-data';

export interface ITokenBuy {
  id: string;
  hash: string;
  type: string;
  status: TTokenBuyStatus;
  amount: number;
  utr: string | null;
  usdt_amount: number;
  exchange_rate: number;
  trader_id: number;
  customer_transaction_id: string | null;
  external_order_id: string | null;
  trader_wallet_id: number;
  dispute_available_at: string | null;
  expires_at: string | null;
  created_at: string;
  updated_at: string;
  dispute_file_url: string | null;
  wallet_address: string | null;

  actions: string;
}

export const TOKEN_BUY_STATUSES = ['new', 'pending', 'success', 'failed', 'cancelled'] as const;
export type TTokenBuyStatus = (typeof TOKEN_BUY_STATUSES)[number];

// Table types
export type ITokenBuyTableColumns = TTableColumnTitles<
  Pick<
    ITokenBuy,
    | 'trader_id'
    | 'amount'
    | 'usdt_amount'
    | 'status'
    | 'wallet_address'
    | 'created_at'
    | 'updated_at'
  >
>;

// Filter types
export type ITokenBuyFilter = TTableColumnsFilter<ITokenBuyTableColumns>;

export type ITokenBuyQuery = IBaseRequestQuery & ITokenBuyFilter;
export type ITokenBuyResponse = IDataResponse<ITokenBuy>;

// CRUD types
export interface IApproveTokenBuyQuery {
  id: string;
  actual_amount: string;
}
export interface IApproveTokenBuyResponse {
  id: string;
}

export interface IRejectTokenBuyQuery {
  id: string;
}
export interface IRejectTokenBuyResponse {
  id: string;
}
